module.exports = __webpack_public_path__ + "img/img2.a0202b59.png";